<template>
  <div class="container">
    <b-row>
      <b-col class="text-left">
        <h2 class="title-lab">Laboratório</h2>
      </b-col>
    </b-row>
    <formAddGeral />
  </div>
</template>

<script>
import formAddGeral from "@/components/laboratorio/formAdd/formAddGeral.vue";

export default {
  name: "addPrescritor",
  components: {
    formAddGeral,
  },
  methods: {
    cancelF() {
      this.$router.push("/laboratorio");
    },
  },
};
</script>


<style>
.title-lab {
  font-weight: 900;
  font-size: 2.5em;
  color: #cf0209;
  font-family: "Segoe_UI_Black_2";
  letter-spacing: 1px;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  width: 150px;
  color: #495057;
  background-color: #e6e6e6;
  color: #cf0209;
}

.nav-tabs .nav-link {
  width: 150px;
  background-color: #e6e6e6;
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.55rem;
  border-top-right-radius: 0.55rem;
  color: #272727;
  outline: none !important;
  border-width: 0 0 3px !important;
  border-bottom: 3px solid #272727 !important;
  background-color: #e6e6e6;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 0 !important;
}

.nav-tabs {
  border-bottom: none;
}

/*  Mobile  */

@media (max-width: 992px) {
  .title-lab {
    font-size: 1.7em;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    width: 100%;
    font-size: 1em;
  }

  .nav-tabs .nav-link {
    width: 100%;
    font-size: 1em;
  }
}
</style>